import { render, staticRenderFns } from "./SpaNav.vue?vue&type=template&id=408016d4&scoped=true"
import script from "./SpaNav.vue?vue&type=script&lang=js"
export * from "./SpaNav.vue?vue&type=script&lang=js"
import style0 from "./SpaNav.vue?vue&type=style&index=0&id=408016d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408016d4",
  null
  
)

export default component.exports